module.exports = __webpack_public_path__ + "img/faq.b9151d53.jpg";